<div id="component">
  <app-buttons (open)="openPanel()" [buttonsWrap]="'add'"></app-buttons>

  <app-filter [tableName]="'accessControlKuroi'"></app-filter>
</div>

<app-table
  [tableName]="'accessControlKuroi'"
  (addbut)="addbut = $event"
  (duplicate)="duplicateRecord($event)"
></app-table>

<app-panelcustoman
  *ngIf="customanpanel !== undefined"
  [ConfigPanel]="customanpanel"
  [mode]="'I'"
  [ConfigData]="panelData"
></app-panelcustoman>

